"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var ButtonLockUnLockAll = /** @class */ (function (_super) {
    __extends(ButtonLockUnLockAll, _super);
    function ButtonLockUnLockAll(props) {
        return _super.call(this, props) || this;
    }
    ButtonLockUnLockAll.prototype.buttonClick = function () {
        if (this.props.onClick) {
            this.props.onClick();
        }
    };
    ButtonLockUnLockAll.prototype.render = function () {
        return (React.createElement(antd_1.Tooltip, { placement: "bottom", title: React.createElement("div", null, this.props.hint), trigger: "hover" },
            React.createElement(antd_1.Button, { icon: "unlock", ghost: true, type: "primary", style: { margin: "2px", marginBottom: "7px" }, onClick: this.buttonClick.bind(this) })));
    };
    return ButtonLockUnLockAll;
}(React.Component));
exports.default = ButtonLockUnLockAll;



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/buttons/ButtonLockUnLockAll.tsx
// module id = 202
// module chunks = 0